module.exports = __webpack_public_path__ + "img/icon5.d4c67b74.png";